<template>
  <div>
    <report-base
      :reports="listLinkDowloadCSV"
      type="accounting"
      reportBtnWidth="300px"
      containerWidth="600px"
    />
  </div>
</template>

<script>
import ReportBase from './reportBase.vue';

export default {
  name: 'ReportTotal',
  components: {ReportBase},
  data() {
    return {
      listLinkDowloadCSV: [
        {
          title: 'TVOS-GMO請求対応表',
          type: 'TvosGmoCharges',
          reportType: 'general'
        },
        {
          title: 'クレジットカード有効期限別会員データ',
          type: 'CreditCardExpirationReport'
        },
        {
          category: '基準日をとらない帳票（選択された日付は考慮されません）',
          title: 'TVOS顧客・GMO会員対応一覧',
          type: 'TvosGmoClients',
          reportType: 'general',
        },
      ],
    };
  },
};
</script>
